import { VIEW_TONES } from '../ui/Art.tsx';

/** The Foundry area's tone, for every place in it. */
export const TONE = VIEW_TONES.foundry!;
